  "use strict";

  //Detect Mobile
  var isMobile = {
      Android: function() {
          return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
      },
      Safari: function() {
          return navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
      },
      Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Safari() || isMobile.Windows());
      }
  };

if (jQuery('.owl-carousel').length) {
  $(document).ready(function() {
      var slider = $('.owl-carousel').owlCarousel({
          loop: true,
          margin: 30,
          nav: false,
          callbacks: true,
          animateOut: 'fadeOut',
          // rewind: true,
          // autoplaySpeed: 300,
          autoplay: 3000,
          responsive: {
              0: {
                  items: 1
              },
              600: {
                  items: 1
              },
              1000: {
                  items: 1
              }
          }
      });
      $('.owl-item.active').addClass('animation');
      if ($('.owl-item.active').hasClass('animation')) {
          // $(this).parent().removeClass('active');
          setTimeout(function() {
              $('.owl-item.active').removeClass('animation');
          }, 2800);
      }
      slider.on('translate.owl.carousel', function(e) {
          idx = e.item.index;
          $('.owl-item.animation').removeClass('animation');
          $('.owl-item').eq(idx).addClass('animation');
          setTimeout(function() {
              $('.owl-item.active').removeClass('animation');
          }, 2800);
      });
  });
}


$(document).ready(function(){

  $('#nav-icon2').on('click', function(event) {
    $(this).toggleClass('open');
  });

  $('.ham-menu').on('click touchstart', function(event) {
    event.preventDefault();
    $(this).toggleClass("is-active");
    $('html, boody').toggleClass('no-overflow');
    $('.navbar').toggleClass('show');
    $('.single-project-title').toggleClass('z-index');
});


  if (!isMobile.any()) {
    var rellax = new Rellax('.rellax', {
    // center: true
    });
  };

  $('.tcon-click').on('click', function(event) {
    event.preventDefault();
    /* Act on the event */
    $('.projects-list-overlay').toggleClass('active');
    $('.tcon-click').toggleClass('tcon-transform');
  });

});


  // Pressing Esc Key
$(document).keyup(function(e) {
    if (e.keyCode == 27) { // Esc
        $('.projects-list-overlay').removeClass('active');
        $('.tcon-remove--chevron-down').addClass('tcon-transform');
    }
});



$(window).load(function() {
    
    var viewportWidth = $(window).width();
    if (viewportWidth > 991) {
          $(window).scroll(function () {
              var threshold = 10;
              if ($(window).scrollTop() >= threshold)
                  $('header.header-fixed').addClass('fixed');
              else
                  $('header.header-fixed').removeClass('fixed');
              var check = $('body > .wrapper').outerHeight(true) - $("header.header-fixed").outerHeight(true);
              if ($(window).scrollTop() >= check)
                  $('header.header-fixed').addClass('bottom');
              else
                  $('header.header-fixed').removeClass('bottom');
          });
    }
    
    $(window).resize(function () {
    
        if (viewportWidth > 991) {
          $(window).scroll(function () {
              var threshold = 10;
              if ($(window).scrollTop() >= threshold)
                  $('header.header-fixed').addClass('fixed');
              else
                  $('header.header-fixed').removeClass('fixed');
              var check = $('body > .wrapper').outerHeight(true) - $("header.header-fixed").outerHeight(true);
              if ($(window).scrollTop() >= check)
                  $('header.header-fixed').addClass('bottom');
              else
                  $('header.header-fixed').removeClass('bottom');
          });
        }
    });
});
